
export enum RequisitionViewAssigned {
    All = 0, 
    Mine = 1,
    Assigned = 2,
}